<form [formGroup]="formGroup">
  <div fxLayout="column">
    <div fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" class="mb-3">
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'common.status' | translate }}
        </mat-label>
        <mat-select formControlName="status" (selectionChange)="onStatusSelected($event.value)">
          <mat-option *ngFor="let item of authorizationStatuses" [value]="item.value">
            {{ item.viewValue | translate }}
          </mat-option>
        </mat-select>
        <button *ngIf="isFieldLocked('status') && lockingField !== 'status'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('status')">
          <mat-icon>lock</mat-icon>
        </button>
        <button *ngIf="isFieldUnlocked('status') && lockingField !== 'status'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('status')">
          <mat-icon>lock_open</mat-icon>
        </button>
        <button *ngIf="lockingField === 'status'" matSuffix mat-icon-button type="button" disabled>
          <mat-spinner diameter="20"></mat-spinner>
        </button>
      </mat-form-field>
      <mat-form-field fxFlex>
        <mat-label>
          {{ 'dialog.authorization.insurance.label' | translate }}
        </mat-label>
        <mat-select formControlName="insuranceId">
          <mat-option *ngFor="let insurance of patientInsurances" [value]="insurance.id">
            {{ insurance.clinicCarrierName || insurance.clinicCarrierId }}
          </mat-option>
        </mat-select>
        <mat-hint>{{ 'dialog.authorization.insurance.hint' | translate }}</mat-hint>
      </mat-form-field>
    </div>
    <ng-container>
      <div fxLayout="column" class="mb-2">
        <mat-form-field fxFlex>
          <mat-label>
            {{ 'dialog.authorization.facility.label' | translate }}
          </mat-label>
          <mmx-facility-selector-input
            [fullResponse]="true"
            [facilityId]="formGroup.value.facilityId"
            formControlName="facility"
            [required]="true"
          ></mmx-facility-selector-input>
          <button *ngIf="isFieldLocked('facilityId') && lockingField !== 'facilityId'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('facilityId')">
            <mat-icon>lock</mat-icon>
          </button>
          <button *ngIf="isFieldUnlocked('facilityId') && lockingField !== 'facilityId'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('facilityId')">
            <mat-icon>lock_open</mat-icon>
          </button>
          <button *ngIf="lockingField === 'facilityId'" matSuffix mat-icon-button type="button" disabled>
            <mat-spinner diameter="20"></mat-spinner>
          </button>
          <mat-hint>{{ 'dialog.authorization.facility.hint' | translate }}</mat-hint>
        </mat-form-field>
        <mat-error *ngIf="hasOutdatedFlag(OutdatedFlags.WrongFacility)" class="mb-3 pl-3">
          {{ 'dialog.authorization.outdated-warning.' + OutdatedFlags.WrongFacility | translate }}
        </mat-error>
      </div>
      <div fxLayout="column" class="mb-2">
        <mat-form-field fxFlex>
          <mat-label>{{ 'common.referrer' | translate }}</mat-label>
          <mmx-referrer-selector-input formControlName="referrerId"></mmx-referrer-selector-input>
          <button *ngIf="isFieldLocked('referrerId') && lockingField !== 'referrerId'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('referrerId')">
            <mat-icon>lock</mat-icon>
          </button>
          <button *ngIf="isFieldUnlocked('referrerId') && lockingField !== 'referrerId'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('referrerId')">
            <mat-icon>lock_open</mat-icon>
          </button>
          <button *ngIf="lockingField === 'referrerId'" matSuffix mat-icon-button type="button" disabled>
            <mat-spinner diameter="20"></mat-spinner>
          </button>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
        <mat-form-field fxFlex subscriptSizing="dynamic" class="mb-3">
          <mat-label>
            {{ 'dialog.authorization.number.label' | translate }}
          </mat-label>
          <input matInput autocomplete="off" formControlName="number" />
          <mat-hint>{{ 'dialog.authorization.number.hint' | translate }}</mat-hint>
          <mat-error>
            <mmx-form-error [control]="formGroup.get('number')"></mmx-form-error>
          </mat-error>
        </mat-form-field>

        <mat-form-field fxFlex subscriptSizing="dynamic" class="mb-3">
          <mat-label>
            {{ 'dialog.authorization.reference-number.label' | translate }}
          </mat-label>
          <input matInput autocomplete="off" formControlName="referenceNumber" />
          <button *ngIf="isFieldLocked('referenceNumber') && lockingField !== 'referenceNumber'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('referenceNumber')">
            <mat-icon>lock</mat-icon>
          </button>
          <button *ngIf="isFieldUnlocked('referenceNumber') && lockingField !== 'referenceNumber'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('referenceNumber')">
            <mat-icon>lock_open</mat-icon>
          </button>
          <button *ngIf="lockingField === 'referenceNumber'" matSuffix mat-icon-button type="button" disabled>
            <mat-spinner diameter="20"></mat-spinner>
          </button>
          <mat-hint>{{ 'dialog.authorization.reference-number.hint' | translate }}</mat-hint>
          <mat-error>
            <mmx-form-error [control]="formGroup.get('referenceNumber')"></mmx-form-error>
          </mat-error>
        </mat-form-field>
      </div>
      <div fxLayout="row" fxLayoutAlign="space-between start" fxLayoutGap="10px">
        <mat-form-field fxFlex class="mb-3">
          <mat-label>
            {{ 'dialog.authorization.start-date.label' | translate }}
          </mat-label>
          <mmx-date-selector-input formControlName="startAt" tz="UTC"></mmx-date-selector-input>
          <button *ngIf="isFieldLocked('startAt') && lockingField !== 'startAt'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('startAt')">
            <mat-icon>lock</mat-icon>
          </button>
          <button *ngIf="isFieldUnlocked('startAt') && lockingField !== 'startAt'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('startAt')">
            <mat-icon>lock_open</mat-icon>
          </button>
          <button *ngIf="lockingField === 'startAt'" matSuffix mat-icon-button type="button" disabled>
            <mat-spinner diameter="20"></mat-spinner>
          </button>
          <mat-hint>
            {{ 'common.set-to' | translate }}:
            <a class="text-link" (click)="setTo($event, 'startAt', 0)">{{ 'common.today' | translate }}</a>,
            <a class="text-link" (click)="setTo($event, 'startAt', -1)">{{ 'common.yesterday' | translate }}</a>
          </mat-hint>
          <mat-error>
            <mmx-form-error [control]="formGroup.get('startAt')"></mmx-form-error>
          </mat-error>
        </mat-form-field>
        <mat-form-field fxFlex>
          <mat-label>
            {{ 'dialog.authorization.end-date.label' | translate }}
          </mat-label>
          <mmx-date-selector-input formControlName="endAt" tz="UTC"></mmx-date-selector-input>
          <button *ngIf="isFieldLocked('endAt') && lockingField !== 'endAt'" matSuffix mat-icon-button type="button" class="lock-btn" [matTooltip]="'dialog.authorization.locked-field-tooltip' | translate" (click)="unlockField.emit('endAt')">
            <mat-icon>lock</mat-icon>
          </button>
          <button *ngIf="isFieldUnlocked('endAt') && lockingField !== 'endAt'" matSuffix mat-icon-button type="button" class="lock-btn text-muted" [matTooltip]="'dialog.authorization.lock-field-tooltip' | translate" (click)="lockField.emit('endAt')">
            <mat-icon>lock_open</mat-icon>
          </button>
          <button *ngIf="lockingField === 'endAt'" matSuffix mat-icon-button type="button" disabled>
            <mat-spinner diameter="20"></mat-spinner>
          </button>
          <mat-hint fxLayout="row" fxLayoutAlign="start center" style="width: 100%; padding-top: 5px">
            <div>
              {{ 'common.set-to' | translate }}:
              <a class="text-link" (click)="setTo($event, 'endAt', 0)">{{ 'common.today' | translate }}</a>,
              <a class="text-link" (click)="setTo($event, 'endAt', 6, 'months')">+6 {{ 'common.months' | translate }}</a>,
              <a class="text-link" (click)="setTo($event, 'endAt', 1, 'years')">+1 {{ 'common.year' | translate }}</a>
            </div>
            <div *ngIf="diff$ | async as diff" fxFlex class="text-right">
              {{ diff }} {{ 'common.days' | translate }}
            </div>
          </mat-hint>
          <mat-error>
            <mmx-form-error [control]="formGroup.get('endAt')"></mmx-form-error>
          </mat-error>
        </mat-form-field>
      </div>

      <div *ngIf="hasOutdatedFlag(OutdatedFlags.ConflictDates)">
        <mat-error class="mb-3 pl-3">
          {{ 'dialog.authorization.outdated-warning.' + OutdatedFlags.ConflictDates | translate }}
        </mat-error>
      </div>

      <div fxFlex class="mb-3">
        <div class="mb-2">
          {{ 'dialog.authorization.procedures.label' | translate }}
        </div>
        <mmx-auth-cpt-picker
          formControlName="procedureCodes"
          [emptyMessage]="cptPickerEmptyMessage"
          [suggestedCodes]="suggestedProcedureCodes"
          [manuallyEditedFields]="manuallyEditedFields"
          [preventAuthManualOverride]="preventAuthManualOverride"
          [lockingField]="lockingField === 'proceduresData'"
          (unlockField)="unlockField.emit($event)"
          (lockField)="lockField.emit('proceduresData')"
        ></mmx-auth-cpt-picker>
        <mat-hint>
          {{ 'dialog.authorization.procedures.hint' | translate: { codes: procedureCodesDisplay } }}
        </mat-hint>
        <mat-error>
          <mmx-form-error [control]="formGroup.get('procedureCodes')"></mmx-form-error>
          <ng-container *ngIf="hasOutdatedFlag(OutdatedFlags.MissingProcedures)">
            {{ 'dialog.authorization.outdated-warning.' + OutdatedFlags.MissingProcedures | translate }}
          </ng-container>
        </mat-error>
      </div>

      <mat-form-field fxFlex class="mb-3">
        <mat-label>{{ 'dialog.authorization.diagnoses.label' | translate }}</mat-label>
        <mmx-diagnosis-code-chips-selector formControlName="diagnosisCodes" multiple></mmx-diagnosis-code-chips-selector>
        <mat-hint>{{ 'dialog.authorization.diagnoses.hint' | translate: { codes: diagnosisCodes?.join(', ') } }}</mat-hint>
        <mat-error>
          <mmx-form-error [control]="formGroup.get('diagnosisCodes')"></mmx-form-error>
        </mat-error>
      </mat-form-field>

      <mat-slide-toggle class="mb-5" [checked]="includeUnits" (toggleChange)="includeUnits = !includeUnits">
        {{ 'patient-details.authorization-card.include-units' | translate }}
      </mat-slide-toggle>

      <div *ngIf="includeUnits" fxLayout="row" fxLayoutAlign="space-between center" fxLayoutGap="10px" formGroupName="limitations">
        <mat-form-field fxFlex>
          <mat-label>
            {{ 'patient-details.authorization-card.quantity' | translate }}
          </mat-label>
          <input matInput type="number" formControlName="quantity" />
        </mat-form-field>
        <mat-form-field fxFlex>
          <mat-label>
            {{ 'patient-details.authorization-card.quantity-type' | translate }}
          </mat-label>
          <mat-select formControlName="quantityType">
            <mat-option [value]="'visit'">{{ 'patient-details.authorization-card.quantity-types.visit' | translate }}</mat-option>
            <mat-option [value]="'hour'">{{ 'patient-details.authorization-card.quantity-types.hour' | translate }}</mat-option>
            <mat-option [value]="'day'">{{ 'patient-details.authorization-card.quantity-types.day' | translate }}</mat-option>
            <mat-option [value]="'dosage'">{{ 'patient-details.authorization-card.quantity-types.dosage' | translate }}</mat-option>
            <mat-option [value]="'FL'">FL</mat-option>
          </mat-select>
        </mat-form-field>
      </div>

      <ng-container *ngIf="customFieldsService.authorizationFields$ | async as fields">
        <mmx-custom-fields-form
          fxFlex
          *ngIf="fields.length > 0"
          [fields]="fields"
          formControlName="customFields"
        >
          <header class="subheading text-primary uppercase text-xs">
            {{ 'common.custom-fields' | translate }}
          </header>
        </mmx-custom-fields-form>
      </ng-container>
    </ng-container>

    <div class="mb-3">
      <div *ngIf="separateUserAndSystemAuthNotesEnabled" fxLayout="row" fxLayoutAlign="end center" class="mb-2">
        <a class="text-link cursor-pointer text-xs" (click)="toggleSystemNotesEdit()">
          {{ systemNotesEditing ? ('common.cancel' | translate) : ('common.edit' | translate) }}
        </a>
      </div>
      <mat-form-field class="text-input">
        <mat-label>
          {{ (separateUserAndSystemAuthNotesEnabled ? 'dialog.authorization.system-notes.label' : 'common.notes') | translate }}
        </mat-label>
        <textarea
          matInput
          formControlName="note"
          [placeholder]="(separateUserAndSystemAuthNotesEnabled ? 'dialog.authorization.system-notes.placeholder' : 'common.notes') | translate"
          rows="3"
        ></textarea>
      </mat-form-field>
    </div>

    <div *ngIf="separateUserAndSystemAuthNotesEnabled" class="mb-3">
      <mat-form-field class="text-input">
        <mat-label>{{ 'dialog.authorization.manual-notes.label' | translate }}</mat-label>
        <textarea matInput formControlName="manualNotes" [placeholder]="'dialog.authorization.manual-notes.placeholder' | translate" rows="3"></textarea>
      </mat-form-field>
    </div>
  </div>
</form>
